<template>
  <div class="bb-contact">
    <div class="bb-contact-left"
         :class="{'bb-contact-left_active': activePart === 'left'}"
         @click="setActivePart('left')"
         @mouseenter="setActivePart('left')">
      <ContactCompanyCard v-if="currentRouteIsCompany"/>
      <ClientForm v-else-if="clientInfo"
                  @openProforma="openProforma"
                  @setActivePart="setActivePart"
                  :currentContactType="currentContactType"/>
    </div>
    <div class="bb-contact-right"
         :class="{'bb-contact-right_active': activePart === 'right'}"
         @click="setActivePart('right')"
         @mouseenter="setActivePart('right')">
      <div class="bb-contact-right-header">
        <div class="bb-contact-right-header-menu">
          <div
            v-if="isSHowTabs(menuItem)"
            class="bb-contact-right-header-menu-item"
            :class="{'bb-contact-right-header-menu-item_active': activeMenuItem === menuItem.id}"
            v-for="menuItem in rightPanelMenu"
            :key="menuItem.id"
            @click="activeMenuItem = menuItem.id"
          >
            {{menuItem.title}}
          </div>
        </div>
       <div class="bb-contact-right-header-icons"
            :class="{'bb-contact-right-header-icons_company': currentRouteIsCompany}">
         <i class="icon-contact bb-contact-right-header-icons__item bb-contact-right-header-icons__item_contact"
            @mouseenter="showPopupIcon = true"
            @mouseleave="showPopupIcon = false"
            v-if="currentRouteIsCompany"
            @click="goToContactCard()"/>
         <transition name="bounce">
           <div class="bb-contact-right-header-icons__popup bb-popup" v-if="showPopupIcon">
             {{isClientCard ? 'Client\'s card' : 'Partner\'s card'}}
           </div>
         </transition>
         <div @click.stop="openSidebarCompanies = !openSidebarCompanies"
              v-if="$route.params.id !== 'new'"
              class="bb-contact-right-header-icons__item">
           <i class="icon-menu-burger"/>
         </div>
       </div>
      </div>
      <div class="bb-contact-right-streak"></div>
      <vue-perfect-scrollbar class="bb-contact-right-body" ref="bbContactRightPanel">
        <transition name="fade" mode="out-in">
          <component
            :is="getCurrentComponent"
            v-if="clientInfo.id || clientInfo._id"
            v-on:scroll-up="scrollUp"
            @change="scrollUp"
          />
        </transition>
      </vue-perfect-scrollbar>
      <div class="bb-contact-right-streak"></div>
    </div>
    <transition name="fade" mode="out-in">
      <ModalWindow v-if="proformaOpen" @close="proformaOpen = false">
        <template v-slot:buttons>
          <div class="bb-contact__send">
            <ButtonsEdit @edit="proformaEvents.create()"
                         @delete="proformaEvents.cancel()"
                         styles="accent"
                         no-pop-up="false"
                         :left-if="clientInfo.selectServices && clientInfo.hasBankDetails && clientInfo.expireValidate"
                         btn-right-text="CANCEL"
                         btn-left-text="SAVE"/>
          </div>
        </template>
        <ProformaInvoice ref="proformaInvoice" @close="proformaOpen = false"/>
      </ModalWindow>
    </transition>
    <transition name="slide-sidebar">
      <ContactCompanySidebar
        v-if="openSidebarCompanies"
        class="bb-contact-companies"
        :isPartnerCard="isPartnerCard"
        @openCompany="activeMenuItem = 3"
        @close="openSidebarCompanies = false"
     />
    </transition>
  </div>
</template>

<script>
import ClientForm from '@/components/Dissemination/Sales/CRM/ContactCard/ContactForm/ContactForm'
import radio from '@/components/Main/Inputs/radio'
import ProformaInvoice from '@/components/Dissemination/Sales/CRM/ContactCard/ProformaInvoice/ProformaInvoice'
import ContactsApi from '@/api/Contacts/api'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import ButtonsEdit from '@/components/Main/ButtonsEdit/ButtonsEdit'
import ContactHistory from '@/components/Dissemination/Sales/CRM/ContactCard/ContactHistory/ContactHistory'
import ContactProjects from '@/components/Dissemination/Sales/CRM/ContactCard/ContactProjects/ContactProjects'
import ContactDocuments from '@/components/Dissemination/Sales/CRM/ContactCard/ContactDocuments/ContactDocuments'
import ContactFinances from '@/components/Dissemination/Sales/CRM/ContactCard/ContactFinances/ContactFinances'
import ContactCommunication
  from '@/components/Dissemination/Sales/CRM/ContactCard/ContactCommunication/ContactCommunication.vue'
import ContactCompanySidebar
  from '@/components/Dissemination/Sales/CRM/ContactCompany/ContactCompanySidebar/ContactCompanySidebar'
import ContactCompanyCard
  from '@/components/Dissemination/Sales/CRM/ContactCompany/ContactCompanyCard/ContactCompanyCard'
import ContactCompanyVisas
  from '@/components/Dissemination/Sales/CRM/ContactCompany/ContactCompanyVisas/ContactCompanyVisas'
import ContactCompanyHistory
  from '@/components/Dissemination/Sales/CRM/ContactCompany/ContactCompanyHistory/ContactCompanyHistory'
import Popup from '@/components/Main/Popup/Popup'
import {get} from 'lodash'
import ContactCompanyApi from '@/api/ContactCompanies/api'
import { CLIENT_ID, PARTNER_ID } from '@/constants/clientType'

export default {
  name: 'ContactCard',
  props: ['contactType'],
  components: {
    Popup,
    ContactCompanyCard,
    ContactCompanySidebar,
    ClientForm,
    radio,
    ModalWindow,
    ProformaInvoice,
    ContactHistory,
    VuePerfectScrollbar,
    ButtonsEdit,
    ContactProjects,
    ContactDocuments,
    ContactFinances,
    ContactCommunication
  },
  data () {
    return {
      showPopupIcon: false,
      activePart: '',
      activeMenuItem: 0,
      currentContactType: 1,
      popUpOpen: false,
      paramsId: this.$route.params.id,
      proformaOpen: false,
      openSidebarCompanies: false,
      proformaEvents: {
        create: false,
        cancel: false
      },
      rightPanelMenu: [
        {
          id: 0,
          title: 'Projects',
          component: ContactProjects,
          isHide: true
        },
        {
          id: 1,
          title: 'Documents',
          component: ContactDocuments,
          isHide: true
        },
        {
          id: 2,
          title: 'Finances',
          component: ContactFinances
        },
        {
          id: 6,
          title: 'History',
          component: ContactHistory
        },
        {
          id: 7,
          title: 'Communication',
          component: ContactCommunication
        },
        {
          id: 3,
          title: 'Documents',
          component: ContactDocuments,
          company: true
        },
        {
          id: 4,
          title: 'Visas',
          component: ContactCompanyVisas,
          company: true
        },
        {
          id: 5,
          title: 'History',
          component: ContactCompanyHistory,
          company: true
        }
      ]
    }
  },
  computed: {
    isClientCard () {
      return this.currentContactType === CLIENT_ID
    },
    isPartnerCard () {
      return this.currentContactType === PARTNER_ID
    },
    currentRouteIsCompany () {
      return this.$route.name === 'CompanyContact'
    },
    getCurrentComponent () {
      const currentMenuItem = this.rightPanelMenu.find(({id}) => id === this.activeMenuItem) || this.rightPanelMenu[0]
      return currentMenuItem.component
    },
    clientInfo: {
      get: function () {
        return this.$store.getters.clientInfo
      },
      set: function (data) {
        this.$store.dispatch('setClientInfo', data)
      }
    },
    contactId () {
      return this.$route.params.id
    }
  },
  methods: {
    isSHowTabs ({ company = false, isHide = false }) {
      if (company) {
        return this.currentRouteIsCompany
      } else {
        if (this.isPartnerCard && isHide) return false
        return !this.currentRouteIsCompany
      }
    },
    setActivePart (part) {
      this.activePart = part
    },
    openProforma () {
      this.proformaOpen = true
    },
    routeContacts () {
      this.$router.push({name: 'ContactsList'})
    },
    goToContactCard () {
      this.showPopupIcon = false
      this.$router.push({name: 'ContactCard', params: {id: this.contactId}})
    },
    getClient () {
      ContactsApi.getContact(this.$route.params.id)
        .then((resp) => {
          this.clientInfo = resp.data
          this.currentContactType = resp.data.contactType
          if (this.clientInfo.isCreated) {
            const creator = this.clientInfo.userDetails[0]
            const systemHistoryObject = {
              id: 1,
              user: {
                firstName: creator.firstName,
                lastName: creator.lastName,
                username: `${creator.firstName} ${creator.lastName}`,
                image: this.clientInfo.userImage.length > 0
                  ? { path: this.clientInfo.userImage[0].path }
                  : null
              },
              eventDate: this.clientInfo.createdAt,
              eventDescription: this.clientInfo.isCreated,
              height: 13,
              isSystem: true
            }
            this.$store.dispatch('setCardCreatedHistoryEntity', systemHistoryObject)
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getCompanies () {
      ContactCompanyApi.getContactCompanies({client: this.contactId})
        .then((resp) => {
          this.$store.dispatch('setClientCompanies', resp.data.clientcompanies)
        })
        .catch((e) => {
          console.error(e)
        })
    },
    scrollUp () {
      const scroll = get(this.$refs, 'bbContactRightPanel.$el', '')
      if (scroll) {
        scroll.scrollTop = 0
      }
    },
    setDefaultActive () {
      this.activeMenuItem = this.isPartnerCard ? 2 : 0
    }
  },
  watch: {
    currentRouteIsCompany (newVal) {
      this.openSidebarCompanies = false
      this.activeMenuItem = newVal ? 3 : 0
    },
    activeMenuItem () {
      this.scrollUp()
    },
    currentContactType () {
      if (this.$route.params.company) return
      this.setDefaultActive()
    }
  },
  updated () {
    if (this.$refs.proformaInvoice) {
      this.proformaEvents.create = this.$refs.proformaInvoice.createInvoice
      this.proformaEvents.cancel = this.$refs.proformaInvoice.cancelProforma
    }
  },
  beforeMount () {
    this.$store.dispatch('setClientCompanies', {})
    this.currentContactType = this.contactType || CLIENT_ID
    if (this.$route.params.company) {
      this.activeMenuItem = this.$route.params.tab || 3
    }
    if (!this.clientInfo.id && this.paramsId !== 'new') {
      this.getClient()
      this.getCompanies()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../sass/variables";
  @import "../../../../../sass/mixins";

  .bb-contact {
    @include global-font;
    position: relative;
    display: flex;
    justify-content: space-between;
    height: calc(100% + 20px);
    margin: -10px -20px;
    z-index: 1;

    &__send {
      position: relative;
      padding-bottom: 0;
      padding-top: 30px;
      margin-right: 8px;
      display: flex;
      justify-content: flex-end;
      box-shadow: 0 -10px 35px -15px rgba($color-silver, 0.4);
    }

    &-left {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      margin-right: 15px;
      max-height: 100%;
      z-index: 1;

      &_active {
        z-index: 2;
      }

      &-body {
       width: 100%;
      }
    }

    &-right {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;
      max-height: 100%;
      border-radius: 5px;
      background-color: $color-white;
      z-index: 1;

      &_active {
        z-index: 99;
      }

      &-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 1px;
        background-color: $color-white;
        border-bottom: 1px solid $color-wild-sand;

        &-icons {
          position: relative;
          display: grid;
          align-items: center;
          justify-content: center;
          grid-template-columns: repeat(1, 30px);
          grid-gap: 8px;
          margin-right: 22px;
          width: auto;

          &__popup {
            right: 43px;
            color: $color-white;
            background: rgba($color-black, 0.53);
            box-shadow: 0 0 12px rgba($color-black, 0.12);
            width: auto;
            font-size: 11px;
            padding: 6px;
            white-space: nowrap;

            &:before {
              border: 4px solid transparent;
              border-bottom: 5px solid rgba($color-black, 0.53);
              box-shadow: 0 0 12px rgba($color-black, 0.12);
            }
          }

          &_company {
            grid-template-columns: repeat(2, 30px);
          }

          &__item {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            width: 30px;
            height: 30px;
            color: $color-accent;
            background: rgba($color-accent, 0.11);
            border-radius: 50%;
            cursor: pointer;
            transition: 0.3s;

            &_contact {
              font-size: 14px;
            }

            &:hover {
              color: $color-accent-hover;
              background: rgba($color-accent-hover, 0.11);
            }
          }
        }

        &-menu {
          display: flex;
          align-items: flex-end;

          &-item {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 18px 24px;
            font-weight: 600;
            font-size: 15px;
            line-height: 18px;
            color: $color-accent;
            margin-right: 32px;
            cursor: pointer;

            &:after {
              content: '';
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              border-radius: 3px 4px 0 0;
              background-color: $color-accent;
              transition: 0.3s;
              opacity: 0;
              height: 0;
            }

            &_active {
              pointer-events: none;

              &:after {
                opacity: 1;
                height: 3px;
              }
            }

            &:hover {
              &:after {
                background-color: $color-accent-hover;
                opacity: 1;
                height: 3px;
              }
            }
          }
        }
      }

      &-streak {
        min-height: 20px;
        width: 100%;
        background-color: $color-white;
      }

      &-body {
        width: 100%;
        height: 100%;
        background-color: $color-white;
      }
    }

    &-companies {
      position: fixed;
      top: 30px;
      bottom: 30px;
      right: 30px;
      z-index: 199;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactCard.vue